import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

import { TSIconModule, TsBadgeModule, TsButtonModule } from 'tsui';
import { SharedModule } from 'app/shared/shared.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ColumnSelectorComponent } from './column-selector.component';

const TSUI_MODULES = [TsButtonModule, TsBadgeModule, TSIconModule];
@NgModule({
  declarations: [ColumnSelectorComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    SharedModule,
    PipesModule,
    DragDropModule,
    MatBadgeModule,
    ...TSUI_MODULES,
  ],
  exports: [ColumnSelectorComponent],
})
export class ColumnSelectorModule {}
